module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Sketch-4069033c042835c417fa43a8dc3510f1.svg";